import { storage, db, EventosCompletos } from "../../../../firebase/firebasejs";

export const compressImage = async (file, quality = 0.95) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            canvas.toBlob((blob) => resolve(blob), "image/jpeg", quality);
        };
        img.src = URL.createObjectURL(file);
    });
};

export const generateThumbnail = async (file, maxSize = 200) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            let width = img.width;
            let height = img.height;

            if (width > height) {
                if (width > maxSize) {
                    height *= maxSize / width;
                    width = maxSize;
                }
            } else {
                if (height > maxSize) {
                    width *= maxSize / height;
                    height = maxSize;
                }
            }

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.6);
        };
        img.src = URL.createObjectURL(file);
    });
};

export const uploadToFirebase = (eventId, fileName, fullBlob, thumbBlob, onProgress) => {
    return new Promise((resolve, reject) => {
        const fullPath = `fotosEvento/${eventId}/fullSize/${fileName}`;
        const thumbPath = `fotosEvento/${eventId}/thumbs/thumb_${fileName}`;

        const fullRef = storage.ref(fullPath);
        const thumbRef = storage.ref(thumbPath);

        const uploadTaskFull = fullRef.put(fullBlob);

        uploadTaskFull.on("state_changed",
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 50;
                onProgress(progress);
            },
            (error) => reject(error),
            async () => {
                const fullUrl = await fullRef.getDownloadURL();
                const uploadTaskThumb = thumbRef.put(thumbBlob);

                uploadTaskThumb.on("state_changed",
                    (snapshot) => {
                        const progress = 50 + (snapshot.bytesTransferred / snapshot.totalBytes) * 50;
                        onProgress(progress);
                    },
                    (error) => reject(error),
                    async () => {
                        const thumbUrl = await thumbRef.getDownloadURL();
                        resolve({ fullUrl, thumbUrl });
                    }
                );
            }
        );
    });
};

export const onImageUploadComplete = (imageObj, eventId) => {
    console.log("Imagen lista para guardar en servidor:", imageObj);

    var newPostKey = db
        .ref()
        .child(
            EventosCompletos +
            eventId +
            "/fotosEvento/fotos/puntoFotografico_" +
            imageObj.puntoFotografico
        )
        .push().key;

    var updates = {};
    updates[
        EventosCompletos +
        eventId +
        "/fotosEvento/fotos/puntoFotografico_" +
        imageObj.puntoFotografico +
        "/" +
        newPostKey
    ] = imageObj;

    return db.ref().update(updates);
};
